var emptyImage = 'data:image/png;base64,R0lGODlhFAAUAIAAAP///wAAACH5BAEAAAAALAAAAAAUABQAAAIRhI+py+0Po5y02ouz3rz7rxUAOw==',

	animateSpeed = 200,
	intervalPeriod = 500,

	breakpointXL = 1180,
	breakpointL = 1024,
	breakpointM = 768,
	breakpointS = 568,
	breakpointXS = 320,

	windowScrollTop = 0,
	windowScrollLeft = 0,

	now = new Date(),
	nowDay = now.getDate(),
	nowMonth = now.getMonth(),
	nowYear = now.getFullYear(),
	nowWeekDay = now.getDay();
